export default __webpack_public_path__ + "static/media/gi.dad6bf4e.svg";